<div class="content">
    <form [formGroup]="form">

      <input formControlName="firstName" [placeholder]="'labels.first-name' | translate" type="text" pInputText/>
      <input formControlName="lastName" [placeholder]="'labels.last-name' | translate" type="text" pInputText/>
      <input formControlName="email" [placeholder]="'labels.email' | translate" type="email" pInputText/>
      <input formControlName="phone" [placeholder]="'labels.phone-number' | translate" type="text" pInputText/>


      <!-- <mat-form-field appearance="outline" class="rounded-md">
            <mat-label>{{'Imię' | translate}}</mat-label>
            <input formControlName="firstName" matInput type="text">
      </mat-form-field> -->
      <!-- <mat-form-field appearance="outline" class="rounded-md">
            <mat-label>{{'Nazwisko' | translate}}</mat-label>
            <input formControlName="lastName" matInput type="text">
      </mat-form-field> -->
      <!-- <mat-form-field appearance="outline" class="rounded-md">
            <mat-label>{{'Adres e-mail' | translate}}</mat-label>
            <input formControlName="email" matInput type="email">
      </mat-form-field>
      <mat-form-field appearance="outline" class="rounded-md">
            <mat-label>{{'Numer telefonu' | translate}}</mat-label>
            <input formControlName="phone" matInput type="text">
      </mat-form-field> -->
    </form>
    <!-- <app-button 
        class="mt-2 w-40 submit"
        [isLoading]="isLoading"
        [isFullWidth]="true"
        [isActive]="true"
        innerTextClasses="text-sm"
        spinnerClasses="my-1.5"
        label="{{ 'Zapisz zmiany' | translate | titlecase}}"
        (click)="onSave()"
    >
    </app-button> -->
</div>